import { ITEM_TYPES } from '@wix/advanced-seo-utils';
import { WIX_BLOG, WIX_BOOKINGS, WIX_CHALLENGES, WIX_EVENTS, WIX_GROUPS, WIX_PORTFOLIO, WIX_RESTAURANTS_MENUS_NEW, WIX_STORES } from '@wix/app-definition-ids';
export let TpaPageIds = /*#__PURE__*/function (TpaPageIds) {
  TpaPageIds["productPage"] = "product_page";
  TpaPageIds["blogPost"] = "post";
  TpaPageIds["servicePage"] = "Booking Service Page";
  TpaPageIds["event"] = "events";
  TpaPageIds["portfolioProject"] = "Project";
  TpaPageIds["onlineProgramsVisitorPage"] = "Challenges";
  TpaPageIds["groupPage"] = "group";
  TpaPageIds["restaurantsMenus"] = "Menus";
  return TpaPageIds;
}({});
export const mapAppDefinitionIdToItemType = appDefId => {
  switch (appDefId) {
    case WIX_STORES:
      return ITEM_TYPES.STORES_PRODUCT;
    case WIX_BOOKINGS:
      return ITEM_TYPES.BOOKINGS_SERVICE;
    case WIX_BLOG:
      return ITEM_TYPES.BLOG_POST;
    case WIX_EVENTS:
      return ITEM_TYPES.EVENTS_PAGE;
    case WIX_PORTFOLIO:
      return ITEM_TYPES.PORTFOLIO_PROJECTS;
    case WIX_GROUPS:
      return ITEM_TYPES.GROUPS_PAGE;
    case WIX_CHALLENGES:
      return ITEM_TYPES.CHALLENGES_PAGE;
    case WIX_RESTAURANTS_MENUS_NEW:
      return ITEM_TYPES.RESTAURANTS_MENU_PAGE;
    default:
      return undefined;
  }
};
//# sourceMappingURL=page-mapping.js.map